import { styled } from '@mui/material/styles';

export const StyledBoldText = styled('span')`
  font-weight: 600;
`;
